import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { usePortalData } from "@/components/portal/PortalDataProvider";
import {
  platformSettingsSubNav,
  platformAdminSubNav,
} from "@/lib/navigationItems";

export const Route = createFileRoute("/portal/platform")({
  component: PlatformLayout,
});

// Settings-level route prefixes (org admin)
const settingsRoutePrefixes = [
  "/portal/platform/settings",
  "/portal/platform/users",
  "/portal/platform/groups",
  "/portal/platform/api-keys",
  "/portal/platform/secrets",
  "/portal/platform/subscriptions",
  "/portal/platform/billing",
  "/portal/platform/categories",
  "/portal/platform/theme",
  "/portal/platform/chart-settings",
  // Org-scoped like the rest of this list: the maintenance page scans the
  // SELECTED org's tables, so it needs the org-key remount on org switch.
  "/portal/platform/maintenance",
];

function PlatformLayout() {
  const location = useLocation();
  const { selectedOrganisation } = usePortalData();

  // Determine which sub-nav to show based on current route (supports sub-routes like /groups/$groupId)
  const isSettingsSection = settingsRoutePrefixes.some(
    (prefix) => location.pathname === prefix || location.pathname.startsWith(prefix + "/")
  );
  const items = isSettingsSection
    ? platformSettingsSubNav
    : platformAdminSubNav;

  // Only use org ID as key for settings section (org-scoped pages)
  // Admin section pages are platform-wide and shouldn't refresh on org change
  const orgKey = isSettingsSection
    ? selectedOrganisation?.organisationId ?? "no-org"
    : "platform";

  return (
    <div className="space-y-4">
      <ProductSubNav items={items} />
      <div key={orgKey}>
        <Outlet />
      </div>
    </div>
  );
}
